import React, { useState, useEffect } from 'react';
import './procurementRequest.css';
import Swal from 'sweetalert2';
import { showToast } from '../toastUtils';
import { queuedApiFetch, apiFetch } from '../api';
const formData = new FormData();

function ProcurementRequest({ menuName, ProcurementTermIframe, ProcurementOpenIframe, ProcurementContractTermIframe, ProcurementContractOpenIframe }) {
  const [iframeUrl, setIframeUrl] = useState('');
  const getProcurementTermIframe = ProcurementTermIframe;
  const getProcurementOpenIframe = ProcurementOpenIframe;
  const getProcurementContractTermIframe = ProcurementContractTermIframe;
  const getProcurementContractOpenIframe = ProcurementContractOpenIframe;
  const accountId = localStorage.getItem('accountId');
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = JSON.parse(getProjectDetails);
  // const projectName = selectedProjectDetail.projectName;
  const defaultProjectNumber = selectedProjectDetail.projectNumber;
  const t_cons_proreq_open = 'Consultant Open Tender Document Review & Sign Off';
  const t_cons_proreq_term = 'Term Consultant - Procurement Request';
  const t_cont_proreq_open = 'Contractor Open Tender Document Review & Sign Off';
  const t_cont_proreq_term = 'Term Contractor - Procurement Request';
  const [dataLoading, setDataLoading] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [loading, setLoading] = useState(true);

      const getUserDetails = localStorage.getItem('userDetails');
      const userDetails = getUserDetails ? JSON.parse(getUserDetails): '';
      const userId = userDetails ? userDetails.id : '';
      const getUserEmail = localStorage.getItem('userEmail');
      const getUserAccess = userDetails ? userDetails.access_level : '';
      const [userCompany, setUserCompany] = useState();
      const getUserCompanyDetails =userCompany;
      const [userPermission, setUserPermission] = useState();
      const [userRoleManual, setUserRolesManual] = useState();


    
      const fetchUserRole = async () => {
        const requestOptions = {
          method: 'GET',
          //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
        };
         try {
          const response = await queuedApiFetch(`/project/get_project_role?userid=${userId}&projectid=${defaultProjectNumber}`, requestOptions);
          const data = await response;
      
          if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
          // console.log(data.data); 
          setUserRolesManual(data.data);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setLoading(false); // End loading
        }
      }


  let parametervalue;
  // console.log('user Company Name', getUserCompanyDetails);

  //Parameter passing
  if(getUserCompanyDetails==="NUS"){
    parametervalue=1;
  }else{
    parametervalue=0;
  }
    
  const GlobalPermissionChecker = (
    expectedCompany,
    // accountAdminPermissions = [],
    projectAdminRoles = []
  ) => {
    return !(
      (getUserCompanyDetails === expectedCompany && userPermission === 'account_admin') ||
      (getUserCompanyDetails === expectedCompany && userPermission === 'project_admin' && userRoleManual === '') ||
      (getUserCompanyDetails === expectedCompany && userPermission === 'project_admin' && projectAdminRoles.some(item=>userRoleManual?.includes?.(item)))
    );
  };

  const fetchUserCompany = async () => {
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
     try {
      const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
      const data = await response;
  
      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        setUserCompany(data.data.company_name);
        setUserPermission(data.data.access_level);     
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      // setLoading(false); // End loading
    }
  }

  useEffect(() => {
    if (defaultProjectNumber) {
      fetchUserCompany();
      fetchData();
      fetchUserRole();
    }
  }, []);

  const fetchData = async () => {
    setDataLoading(true);
    const requestOptions = {
      method: "GET",
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
    };

    try {
      const procurementName = (menuName === 'ConsultantProcurementRequest') ?  'consultant' : 'contractor';
      // console.log('ProcurementRequest', procurementName);
      const response = await queuedApiFetch(`/project/get_procurement_list?project_id=${defaultProjectNumber}&procurement=${procurementName}`,
        requestOptions
      );
      const data = await response;
      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        setItemList(data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setDataLoading(false);
    }
  };

  const openPopup = () => {
    Swal.fire({
      title: 'Please make sure you saved your procurement documents in project files and proceed to initiate a procurement request form',
      showCancelButton: true,
      confirmButtonText: 'Term',
      cancelButtonText: 'Open',
      showCloseButton: true,
      customClass: {
        confirmButton: 'swal-confirm-btn',
        cancelButton: 'swal-cancel-btn',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // handleComponentChange(ProcurementTermIframe, 'ConsultantProcurementRequest');
        //setIframeUrl(getProcurementTermIframe);
        // window.location.replace(getProcurementTermIframe);
        if(GlobalPermissionChecker("NUS",['Project Manager (PM)'])){
          showToast.error('You do not have permission to create a procurement request');
          return;
        }else{
        window.submitform(t_cons_proreq_term, formData,'Procurement Consultant_Procurement Request');
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // handleComponentChange(ProcurementOpenIframe, 'ConsultantProcurementRequest');
        //setIframeUrl(getProcurementOpenIframe);
        // window.location.replace(getProcurementOpenIframe);
        if(GlobalPermissionChecker("NUS",['Project Manager (PM)'])){
          showToast.error('You do not have permission to create a procurement request');
          return;
        }else{
        window.submitform(t_cons_proreq_open, formData, 'Procurement Consultant_Procurement Request');
        }
      }
    });
  };

  const openProcurementContractor = () => {
    Swal.fire({
      title: 'Please make sure you saved your procurement documents in project files and proceed to initiate a procurement request form',
      showCancelButton: true,
      confirmButtonText: 'Term',
      cancelButtonText: 'Open',
      showCloseButton: true,
      customClass: {
        confirmButton: 'contractor-swal-confirm-btn',
        cancelButton: 'contractor-swal-cancel-btn',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        //setIframeUrl(getProcurementContractTermIframe);
        // window.location.replace(getProcurementContractTermIframe);

        // if(GlobalPermissionChecker("NUS",['Project Manager (PM)'])){
        //   showToast.error('You do not have permission to create a procurement request');
        //   return;
        // }else{
        // window.submitform(t_cont_proreq_term, formData,'Procurement Contractor_Procurement Request');
        // }

        window.submitform(t_cont_proreq_term, formData,'Procurement Contractor_Procurement Request');
        // handleComponentChange(ProcurementContractTermIframe, 'ContractProcurementRequest');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //setIframeUrl(getProcurementContractOpenIframe);
        // window.location.replace(getProcurementContractOpenIframe);

        // if(GlobalPermissionChecker("NUS",['Project Manager (PM)'])){
        //   showToast.error('You do not have permission to create a procurement request');
        //   return;
        // }else{
        // window.submitform(t_cont_proreq_open, formData, 'Procurement Contractor_Procurement Request');
        // }

        window.submitform(t_cont_proreq_open, formData, 'Procurement Contractor_Procurement Request');
        // handleComponentChange(ProcurementContractOpenIframe, 'ContractProcurementRequest');
      }
    });
  };

  // const submitForm = (template_name, formData, menu) => {
  //   const form = document.createElement('form');
  //   form.method = 'POST';
  //   //form.action = actionUrl;
  //   form.action = `${process.env.REACT_APP_BACKEND_URL}/form_template/form_post`;

  //   formData.append('account_id', accountId);
  //   formData.append('project_id', defaultProjectNumber);
  //      //added 2 parameters for the url
  //  formData.append('menu', menu);
  //  formData.append('nususer', parametervalue);

  //   formData.append('template_name', template_name);
  //   // form.enctype = 'multipart/form-data'; // Required for file uploads

  //   // Append FormData fields as hidden inputs
  //   for (const [key, value] of formData.entries()) {
  //     const input = document.createElement('input');
  //     input.type = 'hidden';
  //     input.name = key;
  //     input.value = value;
  //     form.appendChild(input);
  //   }

  //   document.body.appendChild(form);
  //   form.submit();
  // };

  return (
    // <html>
    //   <body style={{ margin: 0, width: "360%", background: "#f0f0f0", height: "80vh" }}>
      
    //   </body>
    // </html>
    <div style={{width: "100%"}}>
        <div className="header">
          {menuName === 'ConsultantProcurementRequest' ?
            <button id="createNewButton" onClick={openPopup} className="procurementRequest-button">Create new</button>
            :
            <button id="createNewButton" onClick={openProcurementContractor} className="procurementRequest-button">Create new</button>
          }
        </div>
        {/* {iframeUrl && 
        <iframe  title="Power BI Report" style={{width:'100%', height: '600px'}}  src={iframeUrl}  sandbox="allow-scripts allow-same-origin allow-forms allow-popups" referrerpolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
    } */}

        <div /*className="tablewrap"*/ id="proc_req_cont">
          {/* <div className="title-box">List of approved procurement requests</div>
          <p className="subtitle">Please select Contractor to create contract</p> */}
          <div style={{overflowX: "auto"}} className="tablewrap">
            <table className="procurement-table">
              <thead>
                <tr>
                {/* <th>{menuName == 'ConsultantProcurementRequest' ?  'Consultant Name' : 'Contractor Name'}</th> */}
                  <th>Description</th>
                  <th>Procurement Type</th>
                  <th>Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {itemList && itemList.length > 0 ? (
                  itemList.map((item, index) => (
                    <tr key={index}>
                      {/* <td className="consultant-name">{item.consultant_name}</td> */}
                      <td
                        className="consultant-name"
                        // style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                        style={{ color: (item.rec_match_sts)?"black":"red"}}
                      >
                        {item.consultant_name}
                      </td>
                      <td>{item.procurement_type}</td>
                      <td>{item.approved_on}</td>
                      <td>{(item.status === "submitted" && item.approved_on.toLowerCase() !== "rejected") ? "approved" : item.status}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      {dataLoading ? "Loading..." : "No records found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

          </div>
        </div>
    </div>
  );
}

export default ProcurementRequest;
